// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1Ck7r","modalFooterButton":"ModalNotes_modalFooterButton__3089W"};